//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';
import Logo from "assets/img/logo-no-tier.jpg";

//Helpers
import { pointsFormat, currencyFormat, dateFormat } from "helpers/dataFormat"

// Create styles
const styles = StyleSheet.create({
    body: {
        padding: 10,
        width: "100%"
    },
    table1: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    table2: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginBottom: 10,
    },
    table3: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
    },
    table1ColHeader: {
        backgroundColor: "#315496",
        color: "#ffffff",
        width: "100%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0
    },
    table2ColHeader: {
        backgroundColor: "#ffffff",
        color: "#000",
        width: "12.5%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },
    table2Col: {
        width: "12.5%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableColHeader: {
        backgroundColor: "#315496",
        color: "#ffffff",
        width: "10%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },

    tableColHeader3: {
        backgroundColor: "#315496",
        color: "#ffffff",
        width: "4%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },

    tableColHeader4: {
        backgroundColor: "#315496",
        color: "#ffffff",
        width: "16%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },
    tableCol: {
        width: "10%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        textAlign: 'right'
    },

    tableCol3: {
        width: "4%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        textAlign: 'right'
    },

    tableCol4: {
        width: "16%",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        textAlign: 'right'
    },
    table1CellHeader: {
        margin: 1,
        fontSize: 7,
        textAlign: "center",
    },
    tableCellHeader: {
        margin: 1,
        fontSize: 7,
        textAlign: 'center',
        fontWeight: 600
    },

    tableCellHeader3: {
        margin: 1,
        fontSize: 4,
        textAlign: 'center',
        fontWeight: 600
    },


    
    tableCell: {
        margin: '1px',
        fontSize: 7,
    },
    table1Cell: {
        margin: '1px',
        fontSize: 7,
        textAlign: 'center'
    },
    baseRatetableCell: {
        margin: '1px',
        fontSize: 7,
        textAlign: 'right'
    },
    h2: {
        fontSize: 10,
        textDecoration: 'underline',
        fontWeight: 'bold'
    },
    p: {
        fontSize: 10,
        marginLeft: 2
    },
    b: {
        fontSize: 10,
        fontWeight: 500
    },
    emailId: {
        fontSize: 10,
        color: 'skyblue',
        textDecoration: 'underline'
    },
    img: {
        width: '200px',
        borderRight: "1px solid #ddd",
        marginTop: 10,
        marginBottom: 10
    },
    row: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        margin: 5,
    },
    left: {
        flex: 1,
        marginBottom: 20
    },
    right: {
        flex: 1,
        marginBottom: 20
    },
    pageNumber: {
        fontSize: 8,
        textAlign: 'center'
    },
    description: {
        fontSize: 7,
        textDecoration: 'underline'
    }
});


// Create Document Component
export default function StatementPDF({ states, startDate, endDate, setStates }) {
    const { pdfData, lng, org } = states;
    let transactions = pdfData?.transactionHistory;
    let count =0 
    const { t, i18n } = useTranslation()
    // console.log(lng,'raja',org)
    return (
        <Document
            onRender={() => {
                count= count +1
                
                
                document.getElementById("download-pdf").click();
                if(count ==2){
                    setStates({
                        pdfData:[]

                    })
                }
            
                
               
            }}
          
        >
            <Page wrap style={styles.body}>
                <Image style={styles.img} src={Logo} alt="Logo" fixed />
                <View style={styles.row}>
                    <View style={styles.left}>
                        <Text style={styles.row}>
                            <Text style={styles.b}>{`Billing Account Name: `}</Text>
                            <Text style={styles.p}>{pdfData?.billToName}</Text>
                        </Text>
                        <Text style={styles.row}>
                            <Text style={styles.b}>{`Billing Account Number: `}</Text>
                            <Text style={styles.p}>{pdfData?.billTo}</Text>
                        </Text>
                        <Text style={styles.row}>
                            <Text style={styles.b}>{`Member ID: `}</Text>
                            <Text style={styles.p}>{pdfData?.loyaltyId}</Text>
                        </Text>
                    </View>
                    <View style={styles.right}>
                        <Text style={styles.row}>
                            <Text style={styles.h2}>Thrive Rewards Customer Service Information</Text>
                        </Text>
                        <Text style={styles.row}>
                            <Text style={styles.b}>{`Phone: `}</Text>
                            <Text style={styles.p}>1-800-888-6684 (Mon-Fri 8 AM – 8 PM EST)</Text>
                        </Text>
                        <Text style={styles.row}>
                            <Text style={styles.b}>{`Email: `}</Text>
                            <Text style={styles.emailId}>ThriveRewards@henryschein.com</Text>
                        </Text>
                        {/* <Text style={styles.row}>
                            <Text style={styles.b}>Website:</Text>
                            <Text style={styles.p}>HenryScheinDental.com/ThriveRewards</Text>
                        </Text> */}
                    </View>
                </View>
                <View style={styles.row}>
                    <Text style={styles.row}>
                        <Text style={styles.description}>For a full description of points earned, redemptions, and information related to discounts received, please review your dashboard at HenryScheinDental.com/ThriveRewards.</Text>
                    </Text>
                </View>
                <View style={styles.table1}>
                    <View style={styles.tableRow}>
                        <View style={styles.table1ColHeader}>
                            <Text style={styles.table1CellHeader}>
                                {t("Report Period: ")} {startDate} to {endDate}
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table2}>
                    <View style={styles.tableRow}>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Report Date')}</Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Loyalty ID')}</Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>
                                Starting 
                            </Text>
                            <Text style={styles.tableCellHeader}>
                                Balance
                            </Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>
                                Points
                            </Text>
                            <Text style={styles.tableCellHeader}>
                                Earned
                            </Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>
                                Points
                            </Text>
                            <Text style={styles.tableCellHeader}>
                                Adjusted
                            </Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>
                                Points
                            </Text>
                            <Text style={styles.tableCellHeader}>
                                Redeemed
                            </Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>
                                Points
                            </Text>
                            <Text style={styles.tableCellHeader}>
                                Expired
                            </Text>
                        </View>
                        <View style={styles.table2ColHeader}>
                            <Text style={styles.tableCellHeader}>
                                Ending
                            </Text>
                            <Text style={styles.tableCellHeader}>
                                Balance
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>
                                {moment().format("MM/DD/YYYY")}
                            </Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.loyaltyId}</Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.currentBalance}</Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.pointsEarned}</Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.pointsAdjusted}</Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.pointsRedeemed}</Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.pointsExpired}</Text>
                        </View>
                        <View style={styles.table2Col}>
                            <Text style={styles.table1Cell}>{pdfData?.endingBalance}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table3}>
                    <View style={styles.tableRow} fixed>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Post')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Date')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Ship to')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Account')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Order')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Number')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Transaction')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Type')}</Text>
                        </View>
                        <View style={styles.tableColHeader4}>
                            <Text style={styles.tableCellHeader}>{t('Offer')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Description')}</Text>
                        </View>
                        <View style={styles.tableColHeader3}>
                            <Text style={styles.tableCellHeader}>{t('Offer')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Rate')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Tier')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Base')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Rate')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Purchase')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Amount')}</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{t('Points')}</Text>
                            <Text style={styles.tableCellHeader}>{t('Earned')}</Text>
                        </View>
                    </View>
                    {transactions?.map((t, i) => (
                        <View style={styles.tableRow} key={i}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{t?.transaction_date}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{t?.shipto}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{t?.order_number}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{t?.transaction_type}</Text>
                            </View>
                            <View style={styles.tableCol4}>
                                <Text style={styles.tableCell}>{t?.offer_description}</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.tableCell}>{t?.offer_rate}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{t?.tier}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.baseRatetableCell}>{t?.base_rate}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.baseRatetableCell}>{
                                    parseInt(t?.dollar_amount) >= 0 ?
                                    `$${t?.dollar_amount}` : parseInt(t?.dollar_amount) < 0 ? `-$${t?.dollar_amount.replace('-', '')}` : '-'
                                    // currencyFormat(t?.dollar_amount,lng,org)
                                }</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.baseRatetableCell}>{t?.points}</Text>
                            </View>
                        </View>
                    ))}
                </View>

                <View style={styles.pageNumber} fixed>
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                        `Page ${pageNumber} of ${totalPages}`
                    )} />
                </View>
            </Page>
        </Document>
    );
}

// export default MyDocument;
